import BulkDeleteFileModal from './BulkDeleteFileModal';

export const BULK_DELETE_FILE_MODAL_ID = 'BULK_DELETE_FILE_MODAL_ID';

export default BulkDeleteFileModal;
